module.exports = __webpack_public_path__ + "img/clubs.0f6e3a5d.png";